import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";
import { NineCellLoading } from 'react-loadingg';

import getSetting from "../../services/getSetting";
import updateSetting from "../../services/updateSetting";
import { SketchPicker } from 'react-color';
import Switch from 'react-switch';

import 'moment/locale/it';
import '../../widgets/css/style.css';
import updateConfigurazione from "../../services/updateConfigurazione";
import getCurrentConfigurazione from "../../services/getCurrentConfigurazione";
import ImageInput from "../../widgets/ImageInput";
import SelectBackgroundWidget from "../../widgets/SelectBackgroundWidget";
import translateString from "../../utils/Locales";
import Utils from "../../utils/utils";
import richiediVerificaMail from "../../services/richiediVerificaMail";
import getClient from "../../services/getClient";
import sendMail from "../../services/sendMainEmail";
import { verifyMailBody } from "../../utils/consts";
import ReactHtmlParser from 'react-html-parser';
import verificaFatturazione from "../../services/verificaFatturazione";
import cancelFatturazioneOnline from "../../services/cancelFatturazioneOnline";
import activateFatturazioneOnline from "../../services/activateFatturazioneOnline";
import updateCredenzialiFatturazione from "../../services/updateCredenzialiFatturazione";
import getStudenti from "../../services/getStudenti";
import importaAnagrafiche from "../../services/importaAnagrafiche";
import getInsegnanti from '../../services/getInsegnanti';
import setUnisciAnagrafiche from "../../services/setUnisciAnagrafiche";
import getListaFatturazione from "../../services/getListaFatturazione";
import SelectInput from "../../widgets/SelectInput";

let t = translateString;

export default class AdminSettings extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };

    this.selectMetodoRef = React.createRef();
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.regimeOptions = [
      { value: 'RF0', label: t('seleziona') }, 
      { value: 'RF01', label: 'Ordinario' }, 
      { value: 'RF02', label: 'Contribuenti minimi' },
      { value: 'RF04', label: 'Agricoltura e attività connesse e pesca' }, 
      { value: 'RF05', label: 'Vendita sali e tabacchi' },
      { value: 'RF06', label: 'Commercio fiammiferi' },
      { value: 'RF07', label: 'Editoria' },
      { value: 'RF08', label: 'Gestione servizi telefonia pubblica' },
      { value: 'RF09', label: 'Rivendita documenti di trasporto pubblico e di sosta' },
      { value: 'RF10', label: 'Intrattenimenti, giochi e altre attività di cui alla tariffa allegata al DPR 640/72' },
      { value: 'RF11', label: 'Agenzie viaggi e turismo' },
      { value: 'RF12', label: 'Agriturismo' },
      { value: 'RF13', label: 'Vendite a domicilio' },
      { value: 'RF14', label: 'Rivendita beni usati, oggetti d’arte, d’antiquariato o da collezione' },
      { value: 'RF15', label: 'Agenzie di vendite all’asta di oggetti d’arte, antiquariato o da collezione' },
      { value: 'RF16', label: 'IVA per cassa P.A.' },
      { value: 'RF17', label: 'IVA per cassa' },
      { value: 'RF19', label: 'Regime forfettario' },
      { value: 'RF18', label: 'Altro' }
    ]

    this.userslist = [];

    this.state = {
      testo: '',
      isLoading: true,
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      appBackground: null,
      titleColor: '#000000',
      titleSize: 18,
      addElementVisible: false, 
      mainColor: '', 
      secondaryColor: '', 
      showNewUserWidget: false, 
      student_calendar: true, 
      student_esami: true, 
      student_notifiche: true, 
      student_pagamenti: true, 
      app_about: true, 
      user_info: true,
      teacher_registro: true, 
      teacher_calendar: true, 
      teacher_notifiche: true, 
      teacher_fatturazione: true,
      backColorMenu: '', 
      primaryShow: false,
      secondaryShow: false,
      selectMenu: false,
      menuColor: '',
      fontColor: '', 
      menuShow: false,
      api_uid: '', 
      api_key: '',
      regimeFiscale: { value: 'RF0', label: t('seleziona') },
    }

    this.grid = 2;

  }

  async componentDidMount(){

    this.topRef = React.createRef();

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const db = cookies.get('db', { path: '/' });
    this.dbPath = cookies.get('db_path', { path: '/' });

    Utils.setAnalyticsPage('Admin settings - ' + db);

    this.mail = await getSetting(username, token, 'sendingMailAddress');
    this.mailPassword = await getSetting(username, token, 'sendingMailPassword');
    this.configurazioneAttuale = await getCurrentConfigurazione(username, token, db);
    this.cliente = await getClient('', '', db);

    let reg = this.cliente.regimeFiscale;
    var currReg = { value: reg, label: '' };
    this.regimeOptions.forEach((r) => {
      if (r.value === reg) {
          currReg.label = r.label;
      }
    });

    this.setState({
      mail: this.mail,
      mailPassword: this.mailPassword,
      oldPassword: '',
      newPassword: '',
      confirm: '',
      isLoading: false, 
      isEmailVerificata: this.configurazioneAttuale.configurazioni.email_verified, 
      logo: this.configurazioneAttuale.configurazioni.logoUrl, 
      appBackground: this.configurazioneAttuale.configurazioni.menu_background,
      mainColor: this.configurazioneAttuale.configurazioni.mainColor, 
      secondaryColor: this.configurazioneAttuale.configurazioni.secondaryColor,
      student_calendar: this.configurazioneAttuale.configurazioni.student_calendario === '1' ? true : false, 
      student_esami: this.configurazioneAttuale.configurazioni.student_esami === '1' ? true : false,
      student_notifiche: this.configurazioneAttuale.configurazioni.student_notifiche === '1' ? true : false,
      student_pagamenti: this.configurazioneAttuale.configurazioni.student_pagamenti === '1' ? true : false, 
      app_about: this.configurazioneAttuale.configurazioni.app_about === '1' ? true : false, 
      user_info: this.configurazioneAttuale.configurazioni.user_info === '1' ? true : false,
      teacher_registro: this.configurazioneAttuale.configurazioni.teacher_registro === '1' ? true : false,
      teacher_calendar: this.configurazioneAttuale.configurazioni.teacher_calendario === '1' ? true : false,
      teacher_notifiche: this.configurazioneAttuale.configurazioni.teacher_notifiche === '1' ? true : false,
      teacher_fatturazione: this.configurazioneAttuale.configurazioni.teacher_fatturazione === '1' ? true : false,
      backColorMenu: this.configurazioneAttuale.configurazioni.menu_background_color,
      menuColor: this.configurazioneAttuale.configurazioni.menu_text_color,
      fontColor: this.configurazioneAttuale.configurazioni.menu_font_color,
      isFatturazioneActive: this.cliente.fatturazione_attiva, 
      stato: this.cliente.stato, 
      api_uid: this.cliente.piva,
      regimeFiscale: currReg,
    });
  }

  verifyPiva(piva) {
    if (piva.trim() === '') {
      return false;
    }
  
    if (isNaN(piva) || piva.length < 11) {
      this.setState({ piva_err: true });
      return false;
    } else {
      this.setState({ piva_err: false });
      return true;
    }
  }

  render () {

    const cookies = new Cookies();

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    return (
      <>
        { this.state.isLoading ? <div /> : (
          <div>
        <PageTitle title={t('impostazioni')} />
        <div style={{ display: 'flex', marginTop: -30 }}>
                <img alt="" src={ require('../../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
                <p style={{ fontSize: 12, color: 'darkgray', maxWidth: '80%' }}>{t('background_info')}</p><br/>
          </div>
          <div ref={this.topRef} style={{ ...containerView, paddingTop: '10px', display: 'flex' }}>
              <ImageInput name={'Logo'} key={Math.random()} 
                  value={this.state.logo}
                  onChange={(val) =>           
                    this.setState({ logo: val })
                  }
                />
                <div style={{ marginLeft: 20 }}>
                <ImageInput name={t('sfondo_mobile')} key={Math.random()} 
                  value={this.state.appBackground}
                  onSelect={() => this.setState({ selectMenu: true })}
                  onChange={(val) =>   {        
                    if (val === null || val === '') {
                      this.setState({ menuColor: '' });
                    }
                    this.setState({ appBackground: val });
                    }
                  }
                  colorButton={true}
                  color={this.state.backColorMenu}
                  setColor={(color) => this.setState({ backColorMenu: color })}
                />
                </div>
          </div>
          <PageTitle title={t('impostazioni_email')} />
          <div style={{ display: 'flex', marginTop: -30 }}>
                <img alt="" src={ require('../../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
                <p style={{ fontSize: 12, color: 'darkgray', maxWidth: '80%' }}>{t('impostazioni_email_info')}</p><br/>
          </div>
          <div style={{...containerView, paddingTop: '20px', paddingBottom: '20px'}}>
              <br/>
              { this.state.isEmailVerificata !== '1' && (
                <h4 style={{ fontSize: 14, fontWeight: 'bold', color: 'red', paddingLeft: 5, paddingRight: 30 }}>{t('verifica_mail')}</h4>
              )}
              { this.state.isEmailVerificata === '1' && (
                <h4 style={{ fontSize: 12, fontWeight: 'bold', color: 'green', paddingLeft: 5, paddingRight: 30 }}>{t('email_verificata')}</h4>
              )}
              <TextInput name={t('indirizzo_mail')} value={this.state.mail} autocomplete={false} 
                onChange={(text) => { this.setState({mail: text})}
              } />

              <TextInput name={t('password_email')} value={this.state.mailPassword} autocomplete={false}
                onChange={(text) => { this.setState({mailPassword: text})}
              } />
              <br/>
              { this.state.isEmailVerificata !== '1' && (
                  <FixButton title={t('verifica')} callback={async () => {

                      const username = cookies.get('username', { path: '/' });
                      const token = cookies.get('token', { path: '/' });
                      const db = cookies.get('db', { path: '/' });

                      let secToken = Utils.generateUserToken();
                      let res = await richiediVerificaMail(username, token, secToken);
                      if (res !== null && res.result !== 'KO') {
                          
                          let cliente = await getClient('', '', db);
                          await sendMail(this.state.mail, cliente.ragioneSociale, t('oggetto_ver'), verifyMailBody(cliente.ragioneSociale, secToken, db));
                          Utils.showSuccess(t('mess_inv'));
                      } else {
                          Utils.showError(t('mess_err'));
                      }
                  }} />
              )}
              { this.state.isEmailVerificata !== '1' && (
                <FixButton title={t('controlla_verifica')} callback={async () => {
                    window.location.reload();      
                }} />
              )}
          </div>
          { (false && this.state.stato === 'IT' && this.cliente.type !== '0') && <div>
              <PageTitle title={t('impostazioni_fatturazione')} />
              <div style={{ display: 'flex', marginTop: -30 }}>
                    <img alt="" src={ require('../../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
                    <p style={{ fontSize: 12, color: 'darkgray', maxWidth: '80%' }}>{ReactHtmlParser(t('impostazioni_fatturazione_info'))}</p><br/>
              </div>
              <div style={{...containerView, paddingTop: '20px', paddingBottom: '20px'}}>
                  <br/>
                  { this.state.isFatturazioneActive !== '1' && (
                    <h4 style={{ fontSize: 14, fontWeight: 'bold', color: 'red', paddingLeft: 5, paddingRight: 30 }}>{t('fatt_n_attiva')}</h4>
                  )}
                  { this.state.isFatturazioneActive === '1' && (
                    <h4 style={{ fontSize: 12, fontWeight: 'bold', color: 'green', paddingLeft: 5, paddingRight: 30 }}>{t('fatt_attiva')}</h4>
                  )}
                  <TextInput name={t('piva')} value={this.state.api_uid} autocomplete={false} style={{ width: '290px' }}
                    onChange={(text) => { this.setState({api_uid: text}); this.verifyPiva(text); }
                  } />
                  { this.state.piva_err && (
                    <p style={{ fontSize: 10, fontWeight: 'bold', color: 'red', paddingLeft: 5, paddingRight: 30 }}>{t('piva_err')}</p>
                  )}

                  <SelectInput key={Math.random()} 
                      ref={this.selectMetodoRef}
                      value={this.state.regimeFiscale} 
                      name={t('reg_fiscale')} 
                      options={this.regimeOptions} 
                      isMulti={false}
                      onChange={(option) => {
                          this.setState({
                              regimeFiscale: option
                          }); 
                      }}
                  />
                  <br/>
                    <FixButton title={this.state.isFatturazioneActive === '1' ? t('verifica_api') : t('ver_attiva')} callback={async () => {

                        const username = cookies.get('username', { path: '/' });
                        const token = cookies.get('token', { path: '/' });
                        
                        /*let res = await verificaFatturazione(username, token, this.state.api_uid, this.state.api_key);
                        if (res !== null && res.success) {
                          if (this.state.isFatturazioneActive !== '1') {
                              let r = await activateFatturazioneOnline(username, token, this.state.api_uid, this.state.api_key);
                              if (r !== null && r.result === 'ok') {
                                  Utils.showSuccess(t('fatt_verificata'));
                                  window.location.reload();
                              } else {
                                  Utils.showError(t('errore_imprevisto_f'));
                              }
                          } else {
                          
                            if(this.cliente.fatture_uid !== this.state.api_uid || this.cliente.fatture_key !== this.state.api_key) {
                              let res = await updateCredenzialiFatturazione(username, token, this.state.api_uid, this.state.api_key);
                              if (res !== null && res.result === 'ok') {
                                  Utils.showSuccess(t('fatt_verificata'));
                                  window.location.reload();
                              }
                            } else {
                                Utils.showSuccess(t('fatt_verificata'));
                            }
                          }
                        } else {
                          Utils.showError(t('errore_fatt_k'));
                        }*/

                        if (!this.verifyPiva(this.state.api_uid)) {
                            return;
                        }
                        
                        if (this.state.regimeFiscale.value === 'RF0') {
                          Utils.showError(t('inserire_reg_fisc'));
                          return;
                        }



                      }} />
                  {/* this.state.isFatturazioneActive === '1' && (
                    <>
                        { this.cliente.unito_anagrafiche === '0' && <FixButton title={t('imp_anagrafiche')} callback={async () => {
                            if (window.confirm(t('confirm_ana'))) {
                                
                                this.setState({ isLoading: true });
                                
                                var count = 0;

                                const cookies = new Cookies();
                                let username = cookies.get('username', { path: '/' });
                                let token = cookies.get('token', { path: '/' });
                              
                                var studentsArray = [];
                                let studenti = await getStudenti(username, token);
                                studenti.forEach(s => {
                                  if (s.id_cliente === null && s.codiceFiscale.trim() !== '') {
                                      studentsArray.push(
                                        {
                                          "nome": s.nome + ' ' + s.cognome, 
                                          "indirizzo_via": s.indirizzo, 
                                          "indirizzo_citta": s.citta,
                                          "mail": s.mail, 
                                          "tel": s.telefono, 
                                          "cf": s.codiceFiscale
                                        }
                                      )
                                  }
                                });

                                if (studentsArray.length > 0) {
                                  let res = await importaAnagrafiche(username, token, 'clienti', JSON.stringify(studentsArray));
                                  if (res === null || !res.success) {
                                      Utils.showError(t('errore_imprevisto'));
                                      console.error('Error exporting students');
                                      this.setState({ isLoading: false });
                                      return;
                                  } else {
                                     // TODO: update id_cliente on DB
                                  }
                                }

                                var teachersArray = [];
                                let insegnanti = await getInsegnanti(username, token);
                                insegnanti.forEach(s => {
                                  if (s.id_fornitore === null && (s.codiceFiscale.trim() !== '' || s.piva.trim() !== '')) {
                                      teachersArray.push(
                                        {
                                          "nome": s.nome + ' ' + s.cognome, 
                                          "indirizzo_via": s.indirizzo, 
                                          "indirizzo_citta": s.citta,
                                          "mail": s.mail, 
                                          "tel": s.telefono, 
                                          "cf": s.codiceFiscale, 
                                          "piva": s.piva
                                        }
                                      )
                                  }
                                });

                                if (teachersArray.length > 0) {
                                  let res = await importaAnagrafiche(username, token, 'fornitori', JSON.stringify(teachersArray));
                                  if (res === null || !res.success) {
                                    Utils.showError(t('errore_imprevisto'));
                                    console.error('Error exporting teachers');
                                    this.setState({ isLoading: false });
                                    return;
                                  } else {
                                    // TODO: update id_fornitore on DB
                                  }
                                }

                                await setUnisciAnagrafiche(username, token);
                                Utils.showSuccess(t('salvataggio_fatto'));
                                window.location.reload();
                                //this.setState({ isLoading: false });
                            }
                        }} /> */}

                        { this.cliente.fatturazione_attiva === '1' && <FixButton type={'error'} title={t('disattiva_fatt')} callback={async () => {
                          if (window.confirm(t('confirm_bill_cancel'))) {
                            
                              const cookies = new Cookies();
                              let username = cookies.get('username', { path: '/' });
                              let token = cookies.get('token', { path: '/' });

                              let res = await cancelFatturazioneOnline(username, token);
                              if (res !== null && res.result === 'ok') {
                                Utils.showSuccess(t('fatt_cancellata'));
                                window.location.reload();
                              } else {
                                Utils.showError(t('errore_imprevisto'));
                              }
                          }
                        }} /> }
              </div>
          </div> }
          <PageTitle title={t('personalizzazione_wm')} />
          <div style={{ display: 'flex', marginTop: -30 }}>
                <img alt="" src={ require('../../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
                <p style={{ fontSize: 12, color: 'darkgray', maxWidth: '80%' }}>{t('personalizzazione_info')}</p><br/>
          </div>
          <div style={{...containerView, paddingTop: '20px', paddingBottom: '10px'}}>
          <br/>
          <div style={{display: 'flex'}}>
              <div style={{flex: 1, maxWidth: '300px'}}>
                  <div style={{display: 'flex', marginBottom: 20, marginTop: -10, maxWidth: '300px'}}>
                    <img alt="" style={{ flex: 1, backgroundColor: this.state.mainColor, marginTop: 15, maxWidth: '40px', maxHeight: '20px', cursor: 'pointer' }} onClick={() => this.setState({ primaryShow: !this.state.primaryShow })} />
                    <p style={{flex: 1, marginLeft: 15, marginTop: '14px'}}>{t('colore_primario')}</p>
                  </div>
                  
                  { this.state.primaryShow &&
                      <SketchPicker
                        style={{marginTop: '10px'}}
                        color={this.state.mainColor}
                        onChangeComplete={(hex) => this.setState({ mainColor: hex.hex})}
                      />
                  }
                  
              </div>
              <div style={{flex: 1, maxWidth: '300px'}}>
                  <div style={{display: 'flex', marginBottom: 20, marginTop: -10, maxWidth: '300px'}}>
                    <img alt="" style={{flex: 1, backgroundColor: this.state.secondaryColor, marginTop: 15, maxWidth: '40px', maxHeight: '20px', cursor: 'pointer' }} onClick={() => this.setState({ secondaryShow: !this.state.secondaryShow })} />
                    <p style={{flex: 1, marginLeft: 15, marginTop: '14px'}}>{t('colore_secondario')}</p>
                  </div>
                  
                  { this.state.secondaryShow && 
                      <SketchPicker
                        style={{marginTop: '10px'}}
                        color={this.state.secondaryColor}
                        onChangeComplete={(hex) => this.setState({ secondaryColor: hex.hex}) }
                      />
                  }
              </div>
          </div>
          <div>
            <p style={{ fontFamily: 'Teko', fontSize: 20, color: 'darkgrey', marginTop: 30 }}>{t('sezioni_menu')}</p>
            <div style={{ display: 'flex' }}>
              <span className="settingSpan">{t('calendario_studenti')}</span>
              <Switch uncheckedIcon={false} checkedIcon={false} className="settingSwitch" width={40} height={20} onChange={(checked) => { this.setState({ student_calendar: checked }); }} checked={this.state.student_calendar} />
            </div><br/>
            <div style={{ display: 'flex', marginTop: -10 }}>
              <span className="settingSpan">{t('esami_studenti')}</span>
              <Switch uncheckedIcon={false} checkedIcon={false} className="settingSwitch" width={40} height={20} onChange={(checked) => { this.setState({ student_esami: checked }); }} checked={this.state.student_esami} />
            </div><br/>
            {/*
            <div style={{ display: 'flex', marginTop: -10 }}>
              <span className="settingSpan">{t('notifiche_studenti')}</span>
              <Switch uncheckedIcon={false} checkedIcon={false} className="settingSwitch" width={40} height={20} onChange={(checked) => { this.setState({ student_notifiche: checked }); }} checked={this.state.student_notifiche} />
            </div><br/>
            */}
            <div style={{ display: 'flex', marginTop: -10 }}>
              <span className="settingSpan">{t('pagamenti_studenti')}</span>
              <Switch uncheckedIcon={false} checkedIcon={false} className="settingSwitch" width={40} height={20} onChange={(checked) => { this.setState({ student_pagamenti: checked }); }} checked={this.state.student_pagamenti} />
            </div><br/><br/>
            <div style={{ display: 'flex', marginTop: -10 }}>
              <span className="settingSpan">{t('registro_professori')}</span>
              <Switch uncheckedIcon={false} checkedIcon={false} className="settingSwitch" width={40} height={20} onChange={(checked) => { this.setState({ teacher_registro: checked }); }} checked={this.state.teacher_registro} />
            </div><br/>
            <div style={{ display: 'flex', marginTop: -10 }}>
              <span className="settingSpan">{t('calendario_professori')}</span>
              <Switch uncheckedIcon={false} checkedIcon={false} className="settingSwitch" width={40} height={20} onChange={(checked) => { this.setState({ teacher_calendar: checked }); }} checked={this.state.teacher_calendar} />
            </div><br/>
            {/*
            <div style={{ display: 'flex', marginTop: -10 }}>
              <span className="settingSpan">{t('notifiche_professori')}</span>
              <Switch uncheckedIcon={false} checkedIcon={false} className="settingSwitch" width={40} height={20} onChange={(checked) => { this.setState({ teacher_notifiche: checked }); }} checked={this.state.teacher_notifiche} />
            </div><br/>
            */}
            <div style={{ display: 'flex', marginTop: -10 }}>
              <span className="settingSpan">{t('fatturazione_professori')}</span>
              <Switch uncheckedIcon={false} checkedIcon={false} className="settingSwitch" width={40} height={20} onChange={(checked) => { this.setState({ teacher_fatturazione: checked }); }} checked={this.state.teacher_fatturazione} />
            </div><br/><br/>
            <div style={{ display: 'flex', marginTop: -10 }}>
              <span className="settingSpan">{t('info_utente')}</span>
              <Switch uncheckedIcon={false} checkedIcon={false} className="settingSwitch" width={40} height={20} onChange={(checked) => { this.setState({ user_info: checked }); }} checked={this.state.user_info} />
            </div><br/>
            <div style={{ display: 'flex', marginTop: -10 }}>
              <span className="settingSpan">{t('about')}</span>
              <Switch uncheckedIcon={false} checkedIcon={false} className="settingSwitch" width={40} height={20} onChange={(checked) => { this.setState({ app_about: checked }); }} checked={this.state.app_about} />
            </div><br/>
          </div>
          <div style={{flex: 1, maxWidth: '300px'}}>
                  <div style={{display: 'flex', marginBottom: 20, marginTop: -10, maxWidth: '300px'}}>
                    <img alt="" style={{ flex: 1, backgroundColor: this.state.fontColor, marginTop: 15, maxWidth: '40px', maxHeight: '20px', cursor: 'pointer' }} onClick={() => this.setState({ menuShow: !this.state.menuShow })} />
                    <p style={{flex: 1, marginLeft: 15, marginTop: '14px'}}>{t('colore_menu_m')}</p>
                  </div>
                  
                  { this.state.menuShow &&
                      <SketchPicker
                        style={{marginTop: '10px'}}
                        color={this.state.fontColor}
                        onChangeComplete={(hex) => this.setState({ fontColor: hex.hex})}
                      />
                  }
                  
          </div>
          <br/><br/>
          </div>
          <br/>
          <div style={{marginLeft: 6, marginBottom: 10, marginTop: 5}}>DB NAME: {cookies.get('db', { path: '/' })}</div>
          <br/>
          <FixButton title={t('salva')} callback={async () => {
              this.setState({ isLoading: true });
              const cookies = new Cookies();
              const username = cookies.get('username', { path: '/' });
              const token = cookies.get('token', { path: '/' });

              var changed = false;
              if (this.mail != this.state.mail){
                await updateSetting(username, token, 'sendingMailAddress', this.state.mail);
                changed = true;
              }
              if (this.mailPassword != this.state.mailPassword){
                await updateSetting(username, token, 'sendingMailPassword', this.state.mailPassword);
                changed = true;
              }

              if (changed){
                this.mail = this.state.mail;
                this.mailPassword = this.state.mailPassword;
              }

              // Change configuration on server
              let resp = await updateConfigurazione(username, token, this.state.mainColor, this.state.secondaryColor, this.state.logo, this.state.appBackground, this.state.menuColor, this.state.fontColor, this.state.backColorMenu, this.state.student_calendar, this.state.student_esami, this.state.student_notifiche, this.state.student_pagamenti, this.state.app_about, this.state.user_info, this.state.teacher_calendar, this.state.teacher_fatturazione, this.state.teacher_notifiche, this.state.teacher_registro);

              if(resp.result == 'ok') {
                  this.setState({ isLoading: false });
                  alert(t('impostazioni_aggiornate'));

                  cookies.set('mainColor', this.state.mainColor.substring(1), { path: '/' });
                  cookies.set('secondaryColor', this.state.secondaryColor.substring(1), { path: '/' });
                  window.sessionStorage.setItem('primary_color', this.state.mainColor);
                  window.sessionStorage.setItem('secondary_color', this.state.secondaryColor);
                  window.sessionStorage.setItem('logo', this.state.logo);
              } else {
                  this.setState({ isLoading: false });
                  Utils.showError(t('errore_imprevisto'));
                  return;
              }
              
              this.setState({ isLoading: false });
              window.location.reload();
            }} />
          
          <br/><br/>
          
          { this.state.selectMenu && (
            <SelectBackgroundWidget show={this.state.selectMenu} onClose={() => { this.setState({ selectMenu: false }); }} onDone={(img, col) => this.setState({ appBackground: img, menuColor: col })} />
          )}

          </div>
        )}
      </>
    );
  }

}

const containerView = {
  backgroundColor: 'white', 
  borderRadius: '10px', 
  paddingTop: '5px',
  paddingBottom: '20px',
  paddingLeft: '40px',
  boxShadow: '0px 2px 10px lightgrey', 
}


